import { useSelector } from 'react-redux';
import { StoreState } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { AppState } from '../..';

export const useServiceResponse = () => {
	return useSelector((state: StoreState<AppState>) => state.appState.servicesState);
};
